<template>
  <div class="vincular-container container-fluid mt-4">
    <div class="row">
      <!-- Panel de Salas -->
      <div class="col-md-4">
        <div class="card shadow-sm mb-4">
          <div class="card-header py-2">
            <h4 class="mb-0">Seleccionar sala de cultivo</h4>
          </div>
          <div class="card-body p-2">
            <div v-if="salas.length === 0" class="text-center text-muted">
              No hay salas disponibles.
            </div>
            <div v-for="sala in salas" :key="sala.id" class="sala-item mb-2 card"
              :class="{ selected: selectedSala && selectedSala.id === sala.id }" @click="selectSala(sala)">
              <div class="d-flex align-items-center p-2">
                <div class="sala-icon-container me-2">
                  <div class="sala-icon">
                    <font-awesome-icon icon="fas fa-building" size="2x" />
                  </div>
                </div>
                <div class="sala-info flex-grow-1">
                  <h6 class="mb-0">{{ sala.nombre }}</h6>
                  <small class="text-muted">{{ sala.tipo }}</small>
                  <!-- Indicador de plantas vinculadas, si existe -->
                  <small v-if="sala.plantas && sala.plantas.length" class="d-block text-success">
                    {{ sala.plantas.length }} planta(s) vinculadas
                  </small>
                </div>
              </div>
            </div>
            <!-- Resumen de la sala seleccionada (opcional) -->
            <div v-if="selectedSala && salaSummary" class="sala-summary mt-2">
              <h6>Resumen de la Sala</h6>
              <p><strong>Total de Plantas:</strong> {{ salaSummary.totalPlantas }}</p>
              <!-- Otros datos de resumen pueden agregarse aquí -->
            </div>
          </div>
          <!-- Botonera responsiva -->
          <div class="card-footer p-2 d-flex flex-wrap justify-content-center gap-2">
            <button @click="mostrarComponente('AltaSala')" class="btn btn-sm btn-outline-success flex-grow-1">
              <font-awesome-icon icon="fas fa-plus" class="me-1" /> Crear
            </button>
            <button @click="mostrarComponente('EditarSala', selectedSala)"
              class="btn btn-sm btn-outline-primary flex-grow-1" :disabled="!selectedSala">
              <font-awesome-icon icon="fas fa-edit" class="me-1" /> Editar
            </button>
            <button @click="mostrarComponente('EliminarSala', selectedSala)"
              class="btn btn-sm btn-outline-danger flex-grow-1" :disabled="!selectedSala">
              <font-awesome-icon icon="fas fa-trash-alt" class="me-1" /> Eliminar
            </button>
          </div>
        </div>
      </div>

      <!-- Panel de Plantas -->
      <div class="col-md-8">
        <div class="card shadow-sm mb-4">
          <div class="card-header py-2">
            <h4 class="mb-0">Seleccionar Lotes/Plantas (Proyectos Activos)</h4>
          </div>
          <div class="card-body p-2">
            <!-- Filtros: desplegable para seleccionar lote -->
            <div class="d-flex flex-wrap gap-2 mb-3 align-items-center">
              <label class="mb-0">Filtrar por lote (bloqueado):</label>
              <select v-model="selectedLoteFilter" class="form-select form-select-sm" style="max-width: 180px;">
                <option value="">Todos</option>
                <option v-for="lote in uniqueLotes" :key="lote.id" :value="lote.id">
                  {{ lote.nombre }}
                </option>
              </select>
              <button class="btn btn-sm btn-secondary" @click="clearLoteFilter">Limpiar</button>
              <button class="btn btn-sm btn-info" @click="selectAllPlantas">Seleccionar Todo</button>
              <button class="btn btn-sm btn-warning" @click="invertPlantaSelection">Invertir Selección</button>
            </div>

            <!-- Lista de plantas agrupadas por lote (acordeón) -->
            <div v-if="!selectedLoteFilter">
              <!-- pequeño mensaje si no se encuentra un lote el mismo debe estar bloqueado -->
              <div class="alert alert-info d-flex align-items-center justify-content-center mt-3" role="alert"
                style="font-weight: 500;">
                <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="me-2" />
                Si no encuentra un Lote, verifique que el mismo esté <strong class="ms-1">bloqueado</strong>.
              </div>


              <div v-for="grupo in paginatedLoteGroups" :key="grupo.loteId" class="mb-2">
                <div class="accordion" :id="'accordion-' + grupo.loteId">
                  <div class="accordion-item">
                    <h2 class="accordion-header" :id="'heading-' + grupo.loteId">
                      <div class="d-flex w-100 align-items-center">
                        <button class="accordion-button collapsed p-2 flex-grow-1" type="button"
                          data-bs-toggle="collapse" :data-bs-target="'#collapse-' + grupo.loteId" aria-expanded="false"
                          :aria-controls="'collapse-' + grupo.loteId">
                          Lote: {{ grupo.nombre }} ({{ grupo.plantas.length }} plantas)
                          - Seleccionadas: {{ selectedCount(grupo) }}/{{ grupo.plantas.length }}
                        </button>
                        <button class="btn btn-sm btn-outline-info ms-2" @click.stop="toggleLotSelection(grupo)">
                          {{ isLotSelected(grupo) ? 'Deseleccionar Lote' : 'Seleccionar Lote' }}
                        </button>
                      </div>
                    </h2>
                    <div :id="'collapse-' + grupo.loteId" class="accordion-collapse collapse"
                      :aria-labelledby="'heading-' + grupo.loteId" data-bs-parent="#accordionExample">
                      <div class="accordion-body p-2">
                        <div v-for="planta in grupo.plantas" :key="planta.id" class="plant-item card mb-1 p-2"
                          :class="{ selected: selectedPlantas.includes(planta.id) }"
                          @click="togglePlantaSelection(planta)">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <h6 class="mb-0">{{ planta.codigo }}</h6>
                              <small class="text-muted">ID: {{ planta.id }}</small>
                            </div>
                            <div v-if="selectedPlantas.includes(planta.id)">
                              <font-awesome-icon icon="check-circle" class="text-success" size="lg" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




              </div>
              <!-- Paginación de lotes -->
              <nav v-if="totalLotePages > 1" class="mt-2">
                <ul class="pagination pagination-sm justify-content-center mb-0">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="prevPage">Anterior</a>
                  </li>
                  <li class="page-item" v-for="page in totalLotePages" :key="page"
                    :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalLotePages }">
                    <a class="page-link" href="#" @click.prevent="nextPage">Siguiente</a>
                  </li>
                </ul>
              </nav>
            </div>
            <!-- Si se seleccionó un lote para filtrar, mostrar solo ese grupo (sin agrupación colapsable) -->
            <div v-else>
              <div v-for="planta in filteredPlantasBySelectedLote" :key="planta.id" class="plant-item card mb-1 p-2"
                :class="{ selected: selectedPlantas.includes(planta.id) }" @click="togglePlantaSelection(planta)">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h6 class="mb-0">{{ planta.codigo }}</h6>
                    <small class="text-muted">Lote: {{ planta.lote?.nombre || 'N/D' }}</small>
                  </div>
                  <div v-if="selectedPlantas.includes(planta.id)">
                    <font-awesome-icon icon="check-circle" class="text-success" size="lg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Botón y formulario de confirmación -->
        <div class="card shadow-sm p-2 mb-4">
          <div class="d-flex flex-column gap-2">
            <button class="btn btn-primary btn-sm" @click="toggleConfirmForm"
              :disabled="!selectedSala || selectedPlantas.length === 0 || proyectoCerrado">
              Confirmar Movimiento de Plantas a la Sala
            </button>
            <div v-if="showConfirmForm" class="confirm-form p-2 border rounded">
              <div class="mb-2">
                <label for="fecha_asignacion" class="form-label mb-0">Fecha Asignación:</label>
                <input type="date" v-model="confirmForm.fecha_asignacion" class="form-control form-control-sm"
                  id="fecha_asignacion" />
              </div>
              <div class="mb-2">
                <label for="posicion" class="form-label mb-0">Posición:</label>
                <input type="text" v-model="confirmForm.posicion" class="form-control form-control-sm" id="posicion"
                  placeholder="Ej. A1" />
              </div>
              <div class="mb-2">
                <label for="notas" class="form-label mb-0">Notas:</label>
                <textarea v-model="confirmForm.notas" class="form-control form-control-sm" id="notas" rows="2"
                  placeholder="Comentarios..."></textarea>
              </div>
              <div class="d-flex gap-2">
                <button class="btn btn-success btn-sm" @click="confirmarVinculacion">Confirmar</button>
                <button class="btn btn-secondary btn-sm" @click="toggleConfirmForm">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import { mapGetters } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'salaPlantaGestion',
  components: {
    FontAwesomeIcon,
  },
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      salas: [],
      plantas: [],
      selectedSala: null,
      selectedPlantas: [],
      filterLote: '',
      sortLote: '',
      selectedLoteFilter: '',
      currentPage: 1,
      pageSize: 5,
      showConfirmForm: false,
      confirmForm: {
        fecha_asignacion: new Date().toISOString().split('T')[0],
        posicion: '',
        notas: '',
      },
      salaSummary: {
        totalPlantas: 0,
      },
      proyectoCerrado: false,
    };
  },
  computed: {
    ...mapGetters(['getClubActual']),
    uniqueLotes() {
      const lotes = {};
      this.plantas.forEach(planta => {
        if (planta.lote) {
          lotes[planta.lote.id] = planta.lote;
        }
      });
      return Object.values(lotes);
    },
    filteredAndSortedPlantas() {
      let list = this.plantas;
      if (this.selectedLoteFilter) {
        list = list.filter(planta => planta.lote && planta.lote.id == this.selectedLoteFilter);
      } else {
        if (this.filterLote) {
          list = list.filter(planta =>
            planta.lote &&
            planta.lote.nombre.toLowerCase().includes(this.filterLote.toLowerCase())
          );
        }
        if (this.sortLote) {
          list = [...list].sort((a, b) => {
            const loteA = a.lote?.nombre || '';
            const loteB = b.lote?.nombre || '';
            if (this.sortLote === 'asc') {
              return loteA.localeCompare(loteB);
            } else if (this.sortLote === 'desc') {
              return loteB.localeCompare(loteA);
            }
            return 0;
          });
        }
      }
      return list;
    },
    groupPlantasByLote() {
      const groups = {};
      this.filteredAndSortedPlantas.forEach(planta => {
        if (planta.lote) {
          if (!groups[planta.lote.id]) {
            groups[planta.lote.id] = {
              loteId: planta.lote.id,
              nombre: planta.lote.nombre,
              plantas: [],
            };
          }
          groups[planta.lote.id].plantas.push(planta);
        }
      });
      return Object.values(groups);
    },
    paginatedLoteGroups() {
      const groupsArray = this.groupPlantasByLote;
      const start = (this.currentPage - 1) * this.pageSize;
      return groupsArray.slice(start, start + this.pageSize);
    },
    totalLotePages() {
      const groupsArray = this.groupPlantasByLote;
      return Math.ceil(groupsArray.length / this.pageSize);
    },
    filteredPlantasBySelectedLote() {
      return this.filteredAndSortedPlantas;
    },
  },
  mounted() {
    this.proyectoCerrado = axios.get(`/api/proyectos/${this.proyecto_id}`)
      .then(response => {
        const proyecto = response.data;
        this.proyectoCerrado = proyecto.proyecto_cerrado;
      })
      .catch(error => {
        console.error('Error al obtener el proyecto:', error);
      });
    this.fetchSalas();
    this.fetchPlantas();
  },
  methods: {
    async fetchSalas() {
      try {
        const club_id = this.$store.getters.getClubActual.id;
        const res = await axios.get('/api/sala_plantas_salas_con_plantas_activas/', { params: { club_id } });
        this.salas = res.data;
      } catch (error) {
        console.error('Error al obtener salas:', error);
      }
    },
    async fetchPlantas() {
      try {
        const club_id = this.getClubActual.id;
        const proyecto_id = this.proyecto_id;
        const res = await axios.get('/api/sala_plantas_plantas_proyectos_activos', {
          params: { club_id, proyecto_id },
        });
        this.plantas = res.data;
      } catch (error) {
        console.error('Error al obtener plantas:', error);
      }
    },
    selectSala(sala) {
      this.selectedSala = sala;
      // Opcional: si la sala ya tiene plantas vinculadas, marcarlas como seleccionadas
      if (sala.plantas && sala.plantas.length) {
        this.selectedPlantas = sala.plantas.map(item => item.planta_id);
        this.salaSummary.totalPlantas = sala.plantas.length;
      } else {
        this.selectedPlantas = [];
        this.salaSummary.totalPlantas = 0;
      }
    },
    togglePlantaSelection(planta) {
      const index = this.selectedPlantas.indexOf(planta.id);
      if (index === -1) {
        this.selectedPlantas.push(planta.id);
      } else {
        this.selectedPlantas.splice(index, 1);
      }
    },
    selectAllPlantas() {
      this.selectedPlantas = this.filteredAndSortedPlantas.map(planta => planta.id);
    },
    invertPlantaSelection() {
      const allIds = this.filteredAndSortedPlantas.map(planta => planta.id);
      this.selectedPlantas = allIds.filter(id => !this.selectedPlantas.includes(id));
    },
    // Alterna la selección completa de un lote
    toggleLotSelection(grupo) {
      if (this.isLotSelected(grupo)) {
        grupo.plantas.forEach(planta => {
          const index = this.selectedPlantas.indexOf(planta.id);
          if (index !== -1) {
            this.selectedPlantas.splice(index, 1);
          }
        });
      } else {
        grupo.plantas.forEach(planta => {
          if (!this.selectedPlantas.includes(planta.id)) {
            this.selectedPlantas.push(planta.id);
          }
        });
      }
    },
    // Retorna true si todas las plantas del grupo están seleccionadas
    isLotSelected(grupo) {
      return grupo.plantas.every(planta => this.selectedPlantas.includes(planta.id));
    },
    // Retorna el número de plantas seleccionadas de un grupo
    selectedCount(grupo) {
      return grupo.plantas.filter(planta => this.selectedPlantas.includes(planta.id)).length;
    },
    async confirmarVinculacion() {
      const club_id = this.$store.getters.getClubActual.id;

      if (!this.selectedSala || this.selectedPlantas.length === 0) return;


      // Verificar si alguna planta ya está vinculada a otra sala /api/sala_plantas_asignadas_a_salas
      const existenPlantasAsignadasAOtraSala = await axios.get('/api/sala_plantas_asignadas_a_salas', {
        params: { plantas_ids: this.selectedPlantas, club_id, sala_id: this.selectedSala.id },
      });
      const alreadyLinked = existenPlantasAsignadasAOtraSala.data;
      if (alreadyLinked.length > 0) {
        if (!confirm(`Existen ${alreadyLinked.length} planta(s) ya vinculadas a otra sala. Se moverán a la nueva sala y se desvincularán de la anterior ¿Deseas continuar?`)) {
          return;
        }
      }

      try {

        const payload = {
          club_id,
          sala_id: this.selectedSala.id,
          plantas_ids: this.selectedPlantas,
          fecha_asignacion: this.confirmForm.fecha_asignacion,
          posicion: this.confirmForm.posicion,
          notas: this.confirmForm.notas,
        };
        await axios.post('/api/sala_plantas/multiple', payload);
        alert('Plantas vinculadas exitosamente.');
        this.selectedPlantas = [];
        this.showConfirmForm = false;
        this.fetchSalas();
        this.fetchPlantas();
      } catch (error) {
        console.error('Error al vincular plantas:', error);
        alert('Error al vincular plantas.');
      }
    },
    toggleConfirmForm() {
      this.showConfirmForm = !this.showConfirmForm;
    },
    clearLoteFilter() {
      this.selectedLoteFilter = '';
      this.filterLote = '';
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalLotePages) this.currentPage++;
    },
    mostrarComponente() {
      // Método para mostrar componentes dinámicos (alta, editar, eliminar)
    },
  },
};
</script>

<style scoped>
.vincular-container {
  padding: 10px;
  background-color: #f7f8fa;
  font-size: 0.9rem;
}

.sala-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
}

.sala-item.selected {
  background-color: #d4edda;
}

.sala-icon-container {
  width: 60px;
  height: 60px;
}

.sala-icon {
  width: 60px;
  height: 60px;
  background-color: #dee2e6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plant-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
}

.plant-item.selected {
  background-color: #d1ecf1;
}

.plantas-list .card {
  margin-bottom: 6px;
}

.sala-summary {
  font-size: 0.8rem;
  border: 1px solid #ced4da;
  padding: 8px;
  border-radius: 4px;
  background-color: #e9ecef;
  margin-top: 8px;
}

.accordion-button {
  font-size: 0.9rem;
  padding: 6px;
}

.accordion-body {
  font-size: 0.85rem;
  padding: 4px;
}

.card-footer {
  padding: 6px;
}

.pagination {
  margin-top: 10px;
}

@media (max-width: 576px) {
  .btn {
    font-size: 0.75rem;
    padding: 4px 8px;
  }
}
</style>
